"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _styles = require("@material-ui/core/styles");
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultToolbarSelectStyles = function defaultToolbarSelectStyles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.background.default,
      flex: '1 1 100%',
      display: 'flex',
      position: 'relative',
      zIndex: 120,
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: typeof theme.spacing === 'function' ? theme.spacing(1) : theme.spacing.unit,
      paddingBottom: typeof theme.spacing === 'function' ? theme.spacing(1) : theme.spacing.unit,
      '@media print': {
        display: 'none'
      }
    },
    title: {
      paddingLeft: '26px'
    },
    iconButton: {
      marginRight: '24px'
    },
    deleteIcon: {}
  };
};
var TableToolbarSelect = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableToolbarSelect, _react$default$Compon);
  function TableToolbarSelect() {
    var _this;
    _classCallCheck(this, TableToolbarSelect);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableToolbarSelect).apply(this, arguments));
    /**
     * @param {number[]} selectedRows Array of rows indexes that are selected, e.g. [0, 2] will select first and third rows in table
     */
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCustomSelectedRows", function (selectedRows) {
      if (!Array.isArray(selectedRows)) {
        throw new TypeError("\"selectedRows\" must be an \"array\", but it's \"".concat(typeof selectedRows, "\""));
      }
      if (selectedRows.some(function (row) {
        return typeof row !== 'number';
      })) {
        throw new TypeError('Array "selectedRows" must contain only numbers');
      }
      var options = _this.props.options;
      if (selectedRows.length > 1 && options.selectableRows === 'single') {
        throw new Error('Can not select more than one row when "selectableRows" is "single"');
      }
      _this.props.selectRowUpdate('custom', selectedRows);
    });
    return _this;
  }
  _createClass(TableToolbarSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        onRowsDelete = _this$props.onRowsDelete,
        selectedRows = _this$props.selectedRows,
        options = _this$props.options,
        displayData = _this$props.displayData,
        _this$props$component = _this$props.components,
        components = _this$props$component === void 0 ? {} : _this$props$component;
      var textLabels = options.textLabels.selectedRows;
      var totalSelectedRows = options.serverTableRowCount;
      var Tooltip = components.Tooltip || _Tooltip.default;
      return /*#__PURE__*/_react.default.createElement(_Paper.default, {
        className: classes.root
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "subtitle1",
        className: classes.title
      }, totalSelectedRows ? totalSelectedRows : selectedRows.data.length, ' ', textLabels.text)), options.customToolbarSelect ? options.customToolbarSelect(selectedRows, displayData, this.handleCustomSelectedRows) : /*#__PURE__*/_react.default.createElement(Tooltip, {
        title: textLabels.delete
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        className: classes.iconButton,
        onClick: onRowsDelete,
        "aria-label": textLabels.deleteAria
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        className: classes.deleteIcon
      }))));
    }
  }]);
  return TableToolbarSelect;
}(_react.default.Component);
_defineProperty(TableToolbarSelect, "propTypes", {
  /** Options used to describe table */
  options: _propTypes.default.object.isRequired,
  /** Current row selected or not */
  rowSelected: _propTypes.default.bool,
  /** Callback to trigger selected rows delete */
  onRowsDelete: _propTypes.default.func,
  /** Extend the style applied to components */
  classes: _propTypes.default.object
});
var _default = (0, _styles.withStyles)(defaultToolbarSelectStyles, {
  name: 'MUIDataTableToolbarSelect'
})(TableToolbarSelect);
exports.default = _default;